export default __webpack_public_path__ + "static/media/pure-thumbnail.079d5730.webp";